import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  create,
  fetchOneByToken,
  updateStatusByToken,
} from 'services/found-pets'

const KEY = 'found-pets'

export function useCreate() {
  return useMutation(create)
}

export function useUpdateStatus() {
  const queryClient = useQueryClient()

  return useMutation(updateStatusByToken, {
    onSuccess: (response) => {
      queryClient.refetchQueries([KEY, response.token])
    },
  })
}

export function useFoundPet(token?: string) {
  return useQuery(
    [KEY, token],
    () => {
      if (token) {
        return fetchOneByToken(token)
      }
    },
    {
      enabled: !!token,
    },
  )
}
